// src/components/PsychologicalProfile.js
import React from 'react';

const PsychologicalProfile = ({ psychProfiles, psychStrengths, psychWeaknesses }) => {
  // Convert profile data into array for easier rendering
  const profileArray = Object.entries(psychProfiles).map(([key, data]) => ({
    id: key,
    label: data.label,
    percentage: data.percentage
  }));
  
  // Sort by percentage for visual display
  profileArray.sort((a, b) => b.percentage - a.percentage);
  
  return (
    <div className="mb-12">
      <h3 className="text-xl font-semibold text-arc-ink mb-4">Psychological Profile</h3>
      
      <div className="grid md:grid-cols-2 gap-8">
        <div className="space-y-4">
          {profileArray.map(profile => (
            <div key={profile.id}>
              <div className="flex justify-between mb-1">
                <span className="text-sm font-medium text-arc-muted">{profile.label}</span>
                <span className="text-sm font-medium text-arc-muted">{profile.percentage.toFixed(1)}%</span>
              </div>
              <div className="w-full bg-white/[0.08] rounded-full h-2.5">
                <div 
                  className="bg-indigo-500 h-2.5 rounded-full transition-all duration-1000 ease-out" 
                  style={{ width: `${profile.percentage}%` }} 
                />
              </div>
            </div>
          ))}
        </div>
        
        <div>
          <div className="mb-6">
            <h4 className="text-lg font-medium text-arc-ink mb-2">Your Psychological Strengths</h4>
            <ul className="space-y-2">
              {psychStrengths.map((strength, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>{strength.value}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-medium text-arc-ink mb-2">Areas for Development</h4>
            <ul className="space-y-2">
              {psychWeaknesses.map((weakness, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-arc-light mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                  <span>{weakness.value}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PsychologicalProfile;